const rootUrl = [window.location.protocol, '//', window.location.host].join('');
const primaryUrl = `${rootUrl}/var/assets/System/Icons/icons.svg`;
const fallbackUrl = `${rootUrl}/static/icons/icons.svg`;

const createIconTemplateElement = (svgString: string) => {
    const div = document.createElement('div');
    div.className = 'as__icon__template';
    div.innerHTML = svgString;
    document.body.appendChild(div);
};

fetch(primaryUrl)
    .then(response => {
        if (!response.ok) {
            throw new Error(`Status: ${response.status}`);
        }
        return response.text();
    })
    .then(svgText => {
        createIconTemplateElement(svgText);
    })
    .catch(error => {
        console.warn(`Primary icon request failed: ${error}. Trying fallback.`);

        fetch(fallbackUrl)
            .then(fallbackResponse => {
                if (!fallbackResponse.ok) {
                    throw new Error(`Status: ${fallbackResponse.status}`);
                }
                return fallbackResponse.text();
            })
            .then(fallbackSvgText => {
                createIconTemplateElement(fallbackSvgText);
            })
            .catch(fallbackError => {
                console.error(`Fallback icon request also failed: ${fallbackError}`);
            });
    });